import './App.css';
import NavBar from './components/NavBar'
import Footer from './components/Footer'

function App() {
  return (
    <div>
      <NavBar />
      <Footer />
    </div>
  );
}

export default App;
